import React from 'react'

import { Icon } from '@mxenabled/mx-icons'
import { P } from '@mxenabled/mxui'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import { PulseProgressBar } from './ProgressBar'

interface PulseGoalProgressProps {
  backgroundOverride?: string
  goalPercentage: number
  height?: number
  percentageCompleteText: string
  progressColorOverride?: string
}

export const PulseGoalProgress: React.FC<PulseGoalProgressProps> = ({
  backgroundOverride,
  goalPercentage,
  height = 8,
  percentageCompleteText,
  progressColorOverride,
}) => {
  // Do not remove the data-ui-test They are needed for the cypress test in Pulse
  return (
    <Box className="mx-insights-goal-progress" data-ui-test="goal-progress" sx={{ mb: 16 }}>
      <Stack
        sx={{
          alignItems: 'center',
          flexDirection: 'row',
          mb: 8,
          mt: 4,
        }}
      >
        <Icon color="success" fill={true} name="check_circle" size={16} />
        <P
          bold={true}
          className="mx-insights-goal-progress"
          data-ui-test="goal-percentage-complete"
          sx={{ fontSize: 13 }}
        >
          {percentageCompleteText}
        </P>
      </Stack>

      <PulseProgressBar
        backgroundColor={backgroundOverride ? backgroundOverride : 'background.highlight'}
        color={progressColorOverride ? progressColorOverride : 'primary.main'}
        height={height}
        percent={goalPercentage}
      />
    </Box>
  )
}
